import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { slideTransitionVariants, slideTransitionConfig } from '../animations/transitions';

interface QuestionContainerProps {
  children: React.ReactNode;
  isVisible: boolean;
  direction: number;
  onAnimationComplete?: () => void;
}

const QuestionContainer: React.FC<QuestionContainerProps> = ({
  children,
  isVisible,
  direction,
  onAnimationComplete
}) => {
  return (
    <AnimatePresence mode="wait" custom={direction}>
      {isVisible && (
        <motion.div
          key={React.isValidElement(children) && children.key ? children.key : 'empty'}
          custom={direction}
          variants={slideTransitionVariants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={slideTransitionConfig}
          className="w-full h-full absolute inset-0 flex flex-col"
          onAnimationComplete={onAnimationComplete}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default QuestionContainer; 